import { Box, Typography } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import theme from "../../configs/theme";

export default function TopProductosTable({ data }) {
  return (
    <Box
      width="90%"
      height="86%"
      p={1}
      pb={0}
      bgcolor="#171717"
      borderRadius={2}
      display="flex"
      flexDirection="column"
    >
      <Typography variant="h6" fontWeight="bold" color="white" mb={1}>
        Top productos
      </Typography>

      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} barSize={80}>
          <CartesianGrid strokeDasharray="3 3" stroke="#444" />
          <XAxis
            dataKey="name"
            tick={{ fill: "#ccc" }}
            interval={0}
            tickFormatter={(value) =>
              value.length > 15 ? value.slice(0, 15) + "..." : value
            }
          />
          <YAxis tick={{ fill: "#ccc" }} />
          <Tooltip
            contentStyle={{
              backgroundColor: "#333",
              border: "none",
              color: "#fff",
            }}
            labelStyle={{ color: "#ccc" }}
            itemStyle={{ color: "#ccc" }}
          />
          <Bar
            dataKey="total"
            fill={theme.colors.secondary}
            stroke={theme.colors.primary}
            strokeWidth={2}
            radius={[2, 2, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}
